import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/(site)/halloffame/layout.tsx");
